import { createReducer } from '@reduxjs/toolkit';

import {
  // recoveryPasswordResponse,
  RecoveryPasswordIResponse,
} from './post-recovery-password';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type AccountMsReducerState = {
  recoveryPasswordOkResponse?: RecoveryPasswordIResponse;
};

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/
const initialState: AccountMsReducerState = {
  recoveryPasswordOkResponse: {} as RecoveryPasswordIResponse,
};
/* -------------------------------------------------------------------------------------------------
 * reducer
 * -----------------------------------------------------------------------------------------------*/

const accountMsReducer = createReducer(initialState, (builder) => {
  // builder.addCase(recoveryPasswordResponse, (state, { payload }) => {
  //   state.recoveryPasswordOkResponse = payload;
  //   return;
  // });
});

export default accountMsReducer;
